"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HierarchyTreeCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _images = require("../../../assets/images");

var _uuid = require("uuid");

var _style = require("./style");

var _flyout = require("../../flyout");

var _atoms = require("../../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const HierarchyTreeCard = ({
  title,
  showArrow,
  moreOption,
  isEnabled,
  handleOptionClick,
  customOnClick,
  onSave,
  onCancel,
  options,
  rename,
  placeholder,
  ...props
}) => {
  const [selected, setSelected] = (0, _react.useState)(false);
  const [isHover, setIsHover] = (0, _react.useState)(false);
  const [showOptions, setShowOptions] = (0, _react.useState)(false);
  const [editMode, setEditMode] = (0, _react.useState)(rename);
  const [cardTitle, setCardTitle] = (0, _react.useState)(title);
  const [previousTitle, setPreviousTitle] = (0, _react.useState)(title);
  const id = (0, _react.useMemo)(() => (0, _uuid.v4)(), []);

  const handleOptionsButtonClick = event => {
    event.stopPropagation();
    handleOptionClick();
    setShowOptions(!showOptions);
  };

  const handleCardSelect = () => {
    setSelected(select => !select);
  };

  const externalOnClickHandler = () => {
    // Call old internal on click function for backward compatibility
    handleCardSelect(); // Call externally passed onClick method then for extending functionality

    customOnClick();
  };

  const handleOptionSelect = ({
    label
  }) => {
    /*
    	Convert card to edit mode when rename option is clicked otherwise use
    	corresponding user provided option's on click implementation.
    */
    if (label.toUpperCase() === 'RENAME') {
      handleRename();
    }

    const requiredOption = options.find(option => option.name === label);

    if (requiredOption && typeof requiredOption.onClickHandler === 'function') {
      requiredOption.onClickHandler();
    }

    setShowOptions(false);
  };

  const handleRename = () => {
    setEditMode(true);
  };

  const handleSaveEdit = event => {
    event.stopPropagation();
    setEditMode(false);
    setPreviousTitle(cardTitle);
    setShowOptions(false);
    onSave && onSave(cardTitle);
  };

  const handleCancelEdit = event => {
    event.stopPropagation();
    setEditMode(false);
    setCardTitle(previousTitle);
    setShowOptions(false);
    onCancel && onCancel(previousTitle);
  };

  return /*#__PURE__*/_react.default.createElement(_style.StyledTreeCard, _extends({}, props, {
    "data-testid": "tree-card",
    selected: selected,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => {
      setIsHover(false);
      setShowOptions(false);
    },
    onClick: customOnClick ? externalOnClickHandler : handleCardSelect,
    editMode: editMode
  }), editMode && /*#__PURE__*/_react.default.createElement(_style.StyledEditDiv, null, /*#__PURE__*/_react.default.createElement(_atoms.Input, {
    className: "primary editText",
    inputProps: {
      disabled: false,
      value: cardTitle,
      placeholder: placeholder
    },
    showBorderWithFloatedLabel: false,
    onChange: e => setCardTitle(e.target.value)
  }), /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, {
    className: "saveButton",
    icon: "Checkmark",
    isRoundIcon: true,
    onClick: handleSaveEdit
  }), /*#__PURE__*/_react.default.createElement(_atoms.ButtonWithIcon, {
    className: "cancelButton",
    icon: "Close",
    isRoundIcon: true,
    onClick: handleCancelEdit
  })), !editMode && /*#__PURE__*/_react.default.createElement(_style.StyledTitle, null, showArrow && /*#__PURE__*/_react.default.createElement(_style.StyledArrow, {
    "data-testid": "arrow",
    isEnabled: isEnabled
  }, /*#__PURE__*/_react.default.createElement(_images.BlueCaret, null)), cardTitle, isHover && moreOption && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_style.StyledOption, {
    id: id,
    "data-testid": "more-option",
    onClick: event => handleOptionsButtonClick(event)
  }, /*#__PURE__*/_react.default.createElement(_images.Dots, null)), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, {
    show: showOptions,
    className: "primary",
    id: id,
    items: options && options.map(option => {
      return {
        label: option.name
      };
    }),
    offset: 10,
    onSelect: e => handleOptionSelect(e),
    placement: "leftTop",
    width: "200px"
  }))));
};

exports.HierarchyTreeCard = HierarchyTreeCard;
HierarchyTreeCard.defaultProps = {
  showArrow: true,
  moreOption: true,
  isEnabled: false
};
HierarchyTreeCard.propTypes = {
  /** card title */
  title: _propTypes.default.string.isRequired,

  /** show or hide arrow */
  showArrow: _propTypes.default.bool,

  /** show or hide more option (ie three dots) */
  moreOption: _propTypes.default.bool,

  /** enable state which changes arrow color */
  isEnabled: _propTypes.default.bool,

  /** handler for more option (ie three dots) click */
  handleOptionClick: _propTypes.default.func,

  /** handler for extending on click functionality externally */
  customOnClick: _propTypes.default.func,

  /** handle onSave callback function for rename card title, return updated title */
  onSave: _propTypes.default.func,

  /** handle onCancel callback function for rename card title, return previous title */
  onCancel: _propTypes.default.func,

  /** Dynamic list of options for context menu along with onclick implementation of each option*/
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    onClickHandler: _propTypes.default.func.isRequired
  })),

  /** Rename card state - enable/disable */
  rename: _propTypes.default.bool,

  /** Placeholder for input text field*/
  placeholder: _propTypes.default.string
};